import { render, staticRenderFns } from "./RulesCard.vue?vue&type=template&id=27250b49&scoped=true&"
import script from "./RulesCard.vue?vue&type=script&lang=js&"
export * from "./RulesCard.vue?vue&type=script&lang=js&"
import style0 from "./RulesCard.vue?vue&type=style&index=0&id=27250b49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27250b49",
  null
  
)

export default component.exports